// Core design system tokens

// These are our standard colors
export const colors = {
  primary: {
    main: '#0D373D',
    hover: '#0A2A2F',
  },
  gray: {
    50: '#F5F8F9',
    100: '#E4E8EA',
    300: '#7A7D81',
    400: '#4D4F52',
    500: '#1D2125',
  },
  danger: {
    light: '#FFEAEA',
    hover: '#FFD6D6',
    text: '#D32F2F',
  },
  success: '#E2FDCB',
};

// Typography scale
export const typography = {
  size: {
    xs: 'text-xs', // 12px
    sm: 'text-sm', // 14px
    base: 'text-base', // 16px
    lg: 'text-lg', // 18px
    xl: 'text-xl', // 20px
    '2xl': 'text-2xl', // 24px
    '3xl': 'text-3xl', // 30px
  },
  weight: {
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold',
  },
  text: {
    // Headings
    h1: 'text-3xl',
    h2: 'text-xl md:text-2xl lg:text-3xl',
    h3: 'text-lg md:text-xl lg:text-2xl',
    h4: 'text-base sm:text-lg md:text-xl lg:text-xl font-medium',

    // Body text variations
    body: {
      large: 'text-base sm:text-lg lg:text-xl',
      default: 'text-sm sm:text-base lg:text-lg',
      small: 'text-xs sm:text-sm lg:text-base',
      emphasis: 'text-base font-medium',
    },

    // Special cases
    button: 'text-sm sm:text-base lg:text-lg',
    label: 'text-xs sm:text-sm font-medium',
    caption: 'text-xs text-gray-500',
  },
};

// Border radius presets
export const radius = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  base: 'rounded',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  '3xl': 'rounded-3xl',
  full: 'rounded-full',
};
